/* eslint-disable react/jsx-no-leaked-render */
import React, { Fragment, useEffect, useState } from 'react'
import styled from 'styled-components'
import { bool, object, string } from 'prop-types'
import ValidacaoFluxosPagamento from '../components/ValidacaoFluxosPagamento'
import PagamentoComCartaoCredito from './PagamentoComCartaoCredito'
import PagamentoComPix from './PagamentoComPix'
import EscolhaMetodoPagamento from './EscolhaMetodoPagamento'
import { useCartaoCredito } from '../../../contexts/CartaoCreditoContext'
import { useFluxosPagamento } from '../../../contexts/FluxosPagamentoContext'
import { TITULO_TELA_PAGAMENTO } from '../constantsFluxosPagamento'
import { METODO_PAGAMENTO_CARTAO, METODO_PAGAMENTO_PIX } from '../../../constants'
import { isEmptyObject } from '../../../utils/helpers/helpers'
import { useGlobal } from '../../../contexts/GlobalContext'
import { getAssinaturaDoAssociadoPorModalidade } from '../../../utils/helpers/helpersAssinatura'

const Titulo = styled.h3`
  margin-bottom: 30px;
`

const TelaPagamento = ( {
  pixPlanoAnual,
  location,
  etapaAtual,
  primeiraEtapa,
  modalidadeSelecaoPlano
} ) => {
  const {
    dadosEtapas,
    setarDadosEtapas,
    proximaEtapaAutocomplete,
  } = useFluxosPagamento()
  const { dadosGlobaisAssociado, modalidadeURL } = useGlobal()
  const { getCartoes, postCartao } = useCartaoCredito()
  const [ idAssinatura, setIdAssinatura ] = useState()
  const [ metodoPagamentoSelecionado, setMetodoPagamentoSelecionado ] = useState( 1 )
  const [ pagamentoSelecionado, setPagamentoSelecionado ] = useState()
  const [ cadastrouNovoCartao, setCadastrouNovoCartao ] = useState( false )
  const [ postCartaoSucesso, setPostCartaoSucesso ] = useState( false )
  const isCartaoCredito = metodoPagamentoSelecionado === METODO_PAGAMENTO_CARTAO.id
  const isPix = metodoPagamentoSelecionado === METODO_PAGAMENTO_PIX.id

  useEffect(
    () => {
      if ( idAssinatura ) {
        getCartoes( idAssinatura )
      }
    },
    [ idAssinatura ]
  )
  useEffect(
    () => {
      if ( dadosGlobaisAssociado ) {
        const assinaturaObtida = getAssinaturaDoAssociadoPorModalidade(
          dadosGlobaisAssociado.assinaturas,
          modalidadeURL
        )
        if ( assinaturaObtida ) {
          setIdAssinatura( assinaturaObtida.id )
        }
      }
    },
    [ dadosGlobaisAssociado ]
  )
  useEffect(
    () => {
      setarDadosEtapas(
        null,
        etapaAtual.identificador
      )
      if ( !isEmptyObject( pagamentoSelecionado ) ) {
        let dados
        if ( isCartaoCredito && pagamentoSelecionado.metodoPagamento === METODO_PAGAMENTO_CARTAO.slug ) {
          dados = { ...pagamentoSelecionado, 'metodoPagamento': METODO_PAGAMENTO_CARTAO.slug }
        } else if ( isPix && pagamentoSelecionado.metodoPagamento === METODO_PAGAMENTO_PIX.slug ) {
          dados = { ...pagamentoSelecionado, 'metodoPagamento': METODO_PAGAMENTO_PIX.slug }
        }

        if ( dados ) {
          setarDadosEtapas(
            dados,
            etapaAtual.identificador
          )
          if ( isCartaoCredito ) {
            if ( !cadastrouNovoCartao ) {
              proximaEtapaAutocomplete( { etapaAtual } )
            }
          }
        }
      }
    },
    [ metodoPagamentoSelecionado, pagamentoSelecionado ]
  )

  const salvarNovoCartao = async() => {
    if ( cadastrouNovoCartao && !isEmptyObject( pagamentoSelecionado ) ) {
      const response = await postCartao(
        pagamentoSelecionado,
        idAssinatura
      )
      setPostCartaoSucesso( Boolean( response ) )
      if ( response ) {
        const dadosNovoCartao = dadosEtapas[ etapaAtual.identificador ]
        dadosNovoCartao.id = response.cartaoCredito.id
        setPagamentoSelecionado( dadosNovoCartao )
        setarDadosEtapas(
          { dadosNovoCartao },
          etapaAtual.identificador
        )
        return true
      } else {
        return false
      }
    }
  }

  return (
    <ValidacaoFluxosPagamento
      acaoAdicionalBotaoProximo={ cadastrouNovoCartao ? salvarNovoCartao : null }
      etapaAtual={ etapaAtual }
      location={ location }
      primeiraEtapa={ primeiraEtapa }
      sucessoAcao={ postCartaoSucesso }
    >
      <Titulo>{TITULO_TELA_PAGAMENTO}</Titulo>

      <EscolhaMetodoPagamento
        metodoPagamentoSelecionado={ metodoPagamentoSelecionado }
        setMetodoPagamentoSelecionado={ setMetodoPagamentoSelecionado }
      />

      {metodoPagamentoSelecionado && (
        <Fragment>
          {isCartaoCredito && (
            <PagamentoComCartaoCredito
              etapaAtual={ etapaAtual }
              setCadastrouNovoCartao={ setCadastrouNovoCartao }
              setPagamentoSelecionado={ setPagamentoSelecionado }
            />
          )}

          {isPix && (
            <PagamentoComPix
              modalidadeSelecaoPlano={ modalidadeSelecaoPlano }
              pixPlanoAnual={ pixPlanoAnual }
              setPagamentoSelecionado={ setPagamentoSelecionado }
            />
          )}
        </Fragment>
      )}

    </ValidacaoFluxosPagamento>
  )
}

TelaPagamento.defaultProps = {
  'modalidadeSelecaoPlano': null,
  'pixPlanoAnual': false
}

TelaPagamento.propTypes = {
  'etapaAtual': object.isRequired,
  'location': object.isRequired,
  'modalidadeSelecaoPlano': string,
  'pixPlanoAnual': bool,
  'primeiraEtapa': string.isRequired
}

export default TelaPagamento

